// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  // production: false,
  // // url: "https://pgs-sandbox.globalaccelerex.com",
  // url: ` pgsghana-dev.globalaccelerex.com.gh`,
  // accessControl: "https://sandbox-v2.globalaccelerex.com",
  // callbackUrl: "https://enshrlk2nz7yd.x.pipedream.net/",
  // appUser: "peter",
  // appPwd: "peter",
  // notificationSender: "noreply@globalaccelerex.com",
  // activationLink: "https://sandbox.globalaccelerex.com:6029/auth/resetPassword",
  // paymentPageLink: "https://sandbox.globalaccelerex.com:6038/",
  // ghPaymentPageLink: "https://sandbox.globalaccelerex.com:6038/gh/",
  // documentService:
  //   "https://sandbox.globalaccelerex.com/api/accelerex-integrator/v1/admin/create/upload",
  // logoBaseUrl: "https://sandbox.globalaccelerex.com",
  // ghBaseUrl: "https://pgs-dev.globalaccelerex.com.gh",

  production: true,
  url: "https://pgs.globalaccelerex.com",
  accessControl: "https://pgs.globalaccelerex.com",
  callbackUrl: "https://enshrlk2nz7yd.x.pipedream.net/",
  appUser: "rexpay-ui",
  appPwd: "l1soVhZXeHIth2Z",
  notificationSender: "noreply@globalaccelerex.com",
  activationLink: "https://myrexpay.com/auth/resetPassword",
  paymentPageLink: "https://checkout.myrexpay.com/",
  ghPaymentPageLink: "https://checkout.myrexpay.com/gh/",
  documentService:
    "https://sandbox.globalaccelerex.com/api/accelerex-integrator/v1/business/upload",
  logoBaseUrl: "https://pgs.globalaccelerex.com",
  ghBaseUrl: "https://pgs.globalaccelerex.com.gh",
};
